<template>
  <div ref="host">
    <slot></slot>
  </div>
</template>

<script>
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

export default {
  name: "tippy",
  props: {
    placement: { type: String, default: "left" },
    toSelector: { type: String }
  },
  emits: [
    "hide"
  ],
  mounted() {
    this.tippy = tippy(this.toSelector, {
      content: this.$refs.host,
      appendTo: document.body,
      placement: this.placement,
      interactive: true,
      showOnCreate: true,
      hideOnClick: false,
      trigger: "manual",
      popperOptions: {
        modifiers: {
          preventOverflow: {
            padding: 10
          }
        }
      }
    });
  },
  unmounted() {
    this.tippy.forEach(t => t.destroy());
    this.$emit("hide");
  }
}
</script>
